import React, { useState, useEffect, useRef } from 'react';
import Slide from '@mui/material/Slide';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Avatar from '@mui/material/Avatar';
import base64 from 'base64-js';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LayersIcon from '@mui/icons-material/Layers';
import SchoolIcon from '@mui/icons-material/School';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Typography from '@mui/material/Typography';
import PaymentIcon from '@mui/icons-material/Payment';
import DescriptionIcon from '@mui/icons-material/Description';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { ListItemButton, LinearProgress , Menu, MenuItem, Tooltip, CircularProgress } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import PeopleIcon from '@mui/icons-material/People';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ClassIcon from '@mui/icons-material/Class';
import ScheduleIcon from '@mui/icons-material/Schedule';
import GradeIcon from '@mui/icons-material/Grade';
import InventoryIcon from '@mui/icons-material/Inventory';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import SettingsIcon from '@mui/icons-material/Settings';
import SecurityIcon from '@mui/icons-material/Security';
import BuildIcon from '@mui/icons-material/Build';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Divider from '@mui/material/Divider';
import {Chip } from '@mui/material';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import CloseIcon from '@mui/icons-material/Close';
import {
  Paper,
  Grid,
} from '@mui/material';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


//import { Menu, MenuItem } from '@mui/material'; // Import necessary components from Material-UI

const dubaiToIST = (dateStr) => {
  if (!dateStr) return '';

  const cleanedDate = dateStr.replace(/['"]+/g, '');

  const date = new Date(`${cleanedDate}+04:00`);

  if (isNaN(date)) return cleanedDate;

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Asia/Kolkata',
  });
};

const dubaiToISTWithTime = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr + '+04:00');
  if (isNaN(date)) return dateStr;
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });
};

const Sidebar = ({ content }) => {
    const [open, setOpen] = useState(window.innerWidth >= 768); // Set initial state based on screen width
    const [user, setUser] = useState({
        name: 'Krish',
        designation: 'Software Engineer',
    });
const [storageData, setStorageData] = useState(null);
const [loadingStorage, setLoadingStorage] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [MasterOpen, setMasterOpen] = useState(false);
    const [FrontDeskOpen, setFrontDeskOpen] = useState(false);
    const [RegistrationOpen, setRegistrationOpen] = useState(false);
    const [AdmissionOpen, setAdmissionOpen] = useState(false);
    const [FeeOpen, setFeeOpen] = useState(false);
    const [AssignmentOpen, setAssignmentOpen] = useState(false);
    const [AttendanceOpen, setAttendanceOpen] = useState(false);
    const [InventoryOpen, setInventoryOpen] = useState(false);
    const [ExaminationOpen, setExaminationOpen] = useState(false);
    const [PaymentOpen, setPaymentOpen] = useState(false);
    const [ReportOpen, setReportOpen] = useState(false);
    const [CPanelOpen, setCPanelOpen] = useState(false);
    const [BranchOpen, setBranchOpen] = useState(false);
    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth >= 768 ? 240 : 0);
  const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);
const [hasMoreNotifications, setHasMoreNotifications] = useState(false);
const hasMoreRef = useRef(false);
const [notifPageNo, setNotifPageNo] = useState(1);
const notifPageNoRef = useRef(1);
const [loadingMoreNotifs, setLoadingMoreNotifs] = useState(false);
const intervalRef = useRef(null);
const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
const notifListRef = useRef(null);
    const [CourseOpen, setCourseOpen] = useState(false);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState([]);
    const [showCalendar, setShowCalendar] = useState(false); // New state variable
    const [selectedDate, setSelectedDate] = useState(null); // New state variable
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
    const [accountModalOpen, setAccountModalOpen] = useState(false);
    const [loadingModules, setLoadingModules] = useState({}); // New state for tracking loading modules

   const handleAccountModalOpen = () => {
    setAccountModalOpen(true);
    fetchStorageInfo(); // Add this line
};

    const handleAccountModalClose = () => {
        setAccountModalOpen(false);
    };


    // Function to toggle profile dropdown visibility
    let navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const inputRef = useRef(null);
    // Function to handle search term change
    const handleSearchTermChange = async (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        try {
            // Fetch suggestions based on the search term
            const fetchedSuggestions = await fetchSuggestionsFromBackend(value);

            // Update suggestions state
            setSuggestions(fetchedSuggestions);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            // Handle error state here, such as showing an error message to the user
        }
    };

    const fetchStorageInfo = async () => {
    setLoadingStorage(true);
    try {
        const url = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${url}/Storage/GetStorageInfo`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token'),
            },
        });
        if (response.ok) {
            const data = await response.json();
            setStorageData(data.data);
        }
    } catch (error) {
        console.error('Error fetching storage info:', error);
    } finally {
        setLoadingStorage(false);
    }
};

    const fetchSuggestionsFromBackend = async (value) => {
        try {
            // Don't search if the search term is too short
            if (!value || value.trim().length < 1) {
                return [];
            }

            const url = process.env.REACT_APP_BASE_URL;
            const apiUrl = `${url}/ExclusivePermission/GetSearchForm`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    searchTerm: value
                })
            });

            if (response.ok) {
                const responseData = await response.json();

                // Map the response to include all necessary data
                const allSuggestions = responseData.map(item => ({
                    formName: item.formName,
                    formUrl: item.formUrl,
                    formId: item.formId
                }));

                // Filter suggestions on the frontend for real-time filtering
                // This ensures immediate response as user types
                const filteredSuggestions = allSuggestions.filter(suggestion =>
                    suggestion.formName.toLowerCase().includes(value.toLowerCase())
                );

                return filteredSuggestions;
            } else {
                console.error('Failed to fetch suggestions');
                return [];
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            return [];
        }
    };




    const handleSuggestionClick = (suggestion) => {
        setSearchTerm(suggestion.formName);
        setSuggestions([]);

        // Encode the formId from the suggestion
        const encodedFormId = encodeFormId(suggestion.formId);

        // Navigate to the route with both formUrl and encodedFormId
        navigate(`/${suggestion.formUrl.replace(/^\.\.\/\.\.\//, '')}/${encodedFormId}`);
    };

    const handleOutsideClick = (event) => {
        if (inputRef.current && !inputRef.current.contains(event.target)) {
            // Clicked outside the search area
            setSuggestions([]);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        sessionStorage.clear();
        navigate('/');
    };

    const handlePasswordChange = () => {
        // Handle password change logic here
        navigate('/changepassword');
    };



    const toggleProfileDropdown = () => {
        setProfileDropdownOpen(!profileDropdownOpen);
    };


    const OrgName = sessionStorage.getItem('organizationName').replace(/['"]+/g, '');
    const emojiHi = '\u{1F44B}';



    const handleToggleDrawer = () => {
        setOpen(!open);
    };

    const handleCloseDrawer = () => {
        if (open && window.innerWidth < 768) {
            setOpen(false);
        }
    };

    // Add event listener for window resize to toggle drawer based on screen width
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setDrawerWidth(240);
                setOpen(true);
            } else {
                setDrawerWidth(0);
                setOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [open]);


    const moduleIcons = {
        // Default icon for any new module
        default: <LayersIcon />,

        // Specific icons for each module
        Master: <LayersIcon />,
        "Staff Details": <PeopleIcon />,
        Enquiry: <QuestionAnswerIcon />,
        Admission: <AssignmentIcon />,
        "Fee Manage": <AttachMoneyIcon />,
        Fee: <PaymentIcon />,
        "Classroom Management": <ClassIcon />,
        "Time Table": <ScheduleIcon />,
        "Student Details": <SchoolIcon />,
        Assignment: <AssignmentIcon />,
        Examination: <AssessmentIcon />,
        Result: <GradeIcon />,
        Inventory: <InventoryIcon />,
        Transportation: <DirectionsBusIcon />,
        Report: <DescriptionIcon />,
        Settings: <SettingsIcon />,
        "C-Panel": <BuildIcon />,
        "Exclusive_Permission": <SecurityIcon />,
    };



    const fetchModule = async () => {

        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;

            const response = await fetch(`${apiUrl}/ExclusivePermission/Module`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    // connectionString: sessionStorage.getItem('ConnectionString'),
                }),
            });

            if (response.status === 401) {
                // alert('Session expired, please relogin.');
                setSnackbarMessage('Session expired, please relogin.');
                setOpenSnackbar(true);
                setSnackbarSeverity("error");
                navigate('/'); // Redirect to login page
                return; // Exit the function
            }

            if (!response.ok) {
                throw new Error(`Error fetching financial years: ${response.status}`);
            }

            const responseData = await response.json();
            if (responseData.data === null && responseData.msg === "Record Not Found") {
                return; // Exit the function if the record is not found
            }

            setData(responseData);

        } catch (error) {
            console.error('API request error:', error);
            // alert('An error occurred. Please try again later.');
            setSnackbarMessage('An error occurred. Please try again later.');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
        }
    };


    useEffect(() => {
        fetchModule();
    }, []);


    const fetchForm = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;

            const response = await fetch(`${apiUrl}/ExclusivePermission/Module`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    // connectionString: sessionStorage.getItem('ConnectionString'),

                }),
            });

            if (response.ok) {
                const responseData = await response.json();
                setFormData(responseData);
            } else {
                console.error('Account name incorrect');
                // alert('Invalid account name');
                setSnackbarMessage('Invalid account name');
                setOpenSnackbar(true);
                setSnackbarSeverity("error");
            }
        } catch (error) {
            console.error('API request error:', error);
            // alert('An error occurred. Please try again later.');
            setSnackbarMessage('An error occurred. Please try again later');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
        }
    };


    const [moduleOpenState, setModuleOpenState] = useState({});
    const encodeFormId = (formId) => {
        const bytes = new TextEncoder().encode(formId);
        return base64.fromByteArray(bytes);
    };

    const decodeFormId = (encodedFormId) => {
        const bytes = base64.toByteArray(encodedFormId);
        return new TextDecoder().decode(bytes);
    };

    const DropdownMenu = ({ moduleId, items }) => {
        const isLoading = loadingModules[moduleId];
        
        return (
            <Collapse in={moduleOpenState[moduleId]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {isLoading ? (
                        <ListItem sx={{ pl: 6, justifyContent: 'center', py: 2 }}>
                            <CircularProgress 
                                size={24} 
                                sx={{ 
                                    color: 'yellow',
                                    mr: 1
                                }} 
                            />
                            <Typography variant="body2" sx={{ color: 'yellow' }}>
                                Loading...
                            </Typography>
                        </ListItem>
                    ) : (
                        items.map((item) => (
                            <ListItemButton
                                key={item.formId}
                                component={Link}
                                to={`/${item.formUrl.replace(/^\.\.\/\.\.\//, '')}/${encodeFormId(item.formId)}`}
                                sx={{
                                    pl: 6, // Increase left padding to align with parent items
                                    color: 'yellow',
                                }}
                            >
                                {/* Replace icon with a bullet point */}
                                <span style={{ marginRight: '8px', color: 'yellow' }}>•</span>
                                <ListItemText primary={item.formName} />
                            </ListItemButton>
                        ))
                    )}
                </List>
            </Collapse>
        );
    };



    const handleModuleItemClick = async (moduleId) => {
        const isCurrentlyOpen = moduleOpenState[moduleId];
        
        // Close all other module dropdowns
        const updatedModuleOpenState = {};
        Object.keys(moduleOpenState).forEach((key) => {
            updatedModuleOpenState[key] = false;
        });

        // Toggle the clicked module
        updatedModuleOpenState[moduleId] = !isCurrentlyOpen;
        setModuleOpenState(updatedModuleOpenState);

        // Only fetch if opening and not already loaded
        if (!isCurrentlyOpen) {
            // Set loading state for this module
            setLoadingModules(prev => ({ ...prev, [moduleId]: true }));
            
            try {
                const apiUrl = process.env.REACT_APP_BASE_URL;
                const response = await fetch(`${apiUrl}/ExclusivePermission/Form_Authorizer`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify({
                        moduleId,
                    }),
                });

                if (response.ok) {
                    const responseData = await response.json();
                    setFormData(responseData);
                } else {
                    console.error('Error fetching dropdown data for', moduleId);
                    setSnackbarMessage('An error occurred. Please try again later');
                    setOpenSnackbar(true);
                    setSnackbarSeverity("error");
                }
            } catch (error) {
                console.error('API request error:', error);
                setSnackbarMessage('An error occurred. Please try again later');
                setOpenSnackbar(true);
                setSnackbarSeverity("error");
            } finally {
                // Clear loading state
                setLoadingModules(prev => ({ ...prev, [moduleId]: false }));
            }
        }
    };



    const logo = sessionStorage.getItem('clientLogo');
   const lastlogin = dubaiToISTWithTime(sessionStorage.getItem('lastLoginOn'));
    const day = sessionStorage.getItem('leftday');
const expirydate = dubaiToISTWithTime(
    sessionStorage.getItem('expirydate')?.replace(/['"]+/g, '')
);
    const clientImage = sessionStorage.getItem('clientImage');
    const clientName = sessionStorage.getItem('clientName');

const handleNotificationsOpen = (event) => {
    setNotificationsAnchorEl(event.currentTarget);
    setNotifPageNo(1);
    notifPageNoRef.current = 1;
    fetchNotifications(1, false);
};

const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
};


// Updated fetchNotifications function (replace the existing one)
const fetchNotifications = async (pageNo = 1, append = false) => {
    try {
        const url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${url}/NewNotification/GetMyNotifications?PageNo=${pageNo}&PageSize=20`;
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const data = await response.json();
            const items = Array.isArray(data.data) ? data.data : [];
            setNotifications(prev => append ? [...prev, ...items] : items);
            setHasMoreNotifications(items.length === 20);
hasMoreRef.current = items.length === 20;
        } else {
            setNotifications([]);
        }
    } catch (error) {
        console.error('Error fetching notifications:', error);
    }
};

const fetchUnreadCount = async () => {
    try {
        const url = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${url}/NewNotification/GetUnreadCount`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token'),
            },
        });
        if (response.ok) {
            const data = await response.json();
            setUnreadCount(typeof data.unreadCount === 'number' ? data.unreadCount : 0);
        }
    } catch (error) {
        console.error('Error fetching unread count:', error);
    }
};

// Automatic notification polling (on mount + every 10 seconds)
useEffect(() => {
    fetchUnreadCount();
    intervalRef.current = setInterval(fetchUnreadCount, 30000);
    return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
    };
}, []);

const markAsRead = async (recipientId) => {
    setNotifications(prev =>
        prev.map(n => (n.recipientId === recipientId ? { ...n, isRead: true } : n))
    );
    setUnreadCount(prev => Math.max(0, prev - 1));

    try {
        const url = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${url}/NewNotification/MarkAsRead`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ recipientId }),
        });
        if (!response.ok) throw new Error('Failed');
    } catch {
        // Revert on failure
        setNotifications(prev =>
            prev.map(n => (n.recipientId === recipientId ? { ...n, isRead: false } : n))
        );
        setUnreadCount(prev => prev + 1);
        setSnackbarMessage('Failed to mark notification as read');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
    }
};

const markAllAsRead = async () => {
    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    setUnreadCount(0);

    try {
        const url = process.env.REACT_APP_BASE_URL;
        await fetch(`${url}/NewNotification/MarkAllAsRead`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token'),
            },
        });
        fetchUnreadCount();
    } catch {
        setSnackbarMessage('Failed to mark all as read');
        setOpenSnackbar(true);
        setSnackbarSeverity('error');
    }
};


// Helper to sanitize and extract the display name (removes quotes, entities, escaped quotes, and extra parts)
const getDisplayName = (name) => {
    if (!name) return '';
    let n = String(name).trim();

    // Decode common HTML entities for quotes
    n = n.replace(/&quot;|&ldquo;|&rdquo;|&lsquo;|&rsquo;|&apos;|&#39;|&#34;/gi, '');

    // Remove escaped quotes like \\" or \\\'
    n = n.replace(/\\+["']/g, '');

    // Trim surrounding straight or smart quotes and similar characters
    n = n.replace(/^[\s\"'""«»„‟]+|[\s\"'""«»„‟]+$/g, '');

    // If name includes an email or extra parts like <email> or (something), take only the display part.
    if (n.includes('<')) n = n.split('<')[0].trim();
    if (n.includes('(')) n = n.split('(')[0].trim();
    return n;
};

    return (
        <>
            <div style={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backgroundColor: 'white',
                        color: 'purple',
                    }}
                >
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={() => setOpen(!open)}
                            sx={{ color: 'grey', display: { md: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <b className='enriqueta-medium' style={{
                            background: 'linear-gradient(90deg, rgb(152 106 182), rgb(68 28 127))',
                            WebkitBackgroundClip: 'text',
                            fontSize: '24px', // Set the font size to 24 pixels
                            fontWeight: 'bolder',
                            display: 'inline-block',
                            color: 'transparent', // Set the color to transparent
                        }}>
                            Welcome Back <span style={{ color: 'yellow' }}>{emojiHi}</span>
                        </b>


                        {/* Search bar */}
                        <div style={{ position: 'relative', marginLeft: 'auto', marginRight: 10}} ref={inputRef}>
                            <TextField
                                id="search-for-forms"
                                placeholder="Search for forms"
                                value={searchTerm}
                                onChange={handleSearchTermChange}
                                InputProps={{
                                    startAdornment: (
                                        <IconButton edge="start" color="inherit" aria-label="search" sx={{ color: 'grey' }}>
                                            <SearchIcon />
                                        </IconButton>
                                    ),
                                    sx: {
                                        borderRadius: '20px',
                                        backgroundColor: '#f0f0f0',
                                        '& .MuiIconButton-root': {
                                            padding: '8px',
                                        },
                                        '& input': {
                                            height: '30px',
                                            padding: '5px',
                                        },
                                    },
                                }}
                            />
                            {suggestions.length > 0 && (
                                <div style={{ position: 'absolute', top: 'calc(100% + 5px)', left: 0, width: '100%', backgroundColor: '#fff', borderRadius: '8px', zIndex: 999, maxHeight: '300px', overflowY: 'auto' }}>
                                    {suggestions.map((suggestion, index) => (
                                        <div
                                            key={index}
                                            style={{ padding: '8px', borderBottom: '1px solid #ccc', cursor: 'pointer' }}
                                            onClick={() => handleSuggestionClick(suggestion)} // Pass the entire suggestion object
                                        >
                                            {suggestion.formName}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Bell icon */}
               <Badge 
    badgeContent={unreadCount} 
    color="error" 
    invisible={unreadCount === 0}
    sx={{ 
        '& .MuiBadge-badge': { 
            fontSize: '0.8rem',
            minWidth: '20px',
            height: '18px',
            fontWeight: 'bold',
            borderRadius: '50%',
            // right: -8, 
            top: 8,
            boxShadow: '0 2px 2px rgba(244, 67, 54, 0.3)', // Subtle glow for enhancement
            animation: unreadCount > 0 ? 'pulse 2s infinite' : 'none',
        },
    }}
>
    <IconButton
        color="inherit"
        onClick={handleNotificationsOpen}
        sx={{
            ...(unreadCount > 0 && {
                color: 'primary.main',
                '&:hover': { 
                    color: 'primary.dark',
                    transform: 'scale(1.1)',
                    transition: 'all 0.2s ease',
                },
                boxShadow: '0 0 0 1px rgba(25, 118, 210, 0.1)', // Subtle highlight ring
                backgroundColor: 'rgba(25, 118, 210, 0.05)', // Light background tint
                borderRadius: '50%',
            }),
            color: 'inherit',
        }}
    >
        <NotificationsIcon />
    </IconButton>
</Badge>

<Menu
    anchorEl={notificationsAnchorEl}
    open={Boolean(notificationsAnchorEl)}
    onClose={handleNotificationsClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
   PaperProps={{
   sx: {
    width: 400,
    maxWidth: 'calc(100vw - 32px)',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 3,
    boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
    overflow: 'visible',
    p: 0,
},
}}
>
    {/* Header */}
    <Box sx={{
        background: 'linear-gradient(135deg, #0B1F3D 0%, #1a3a6b 100%)',
        px: 2.5, py: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <NotificationsIcon sx={{ color: '#fff', fontSize: 22 }} />
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, fontSize: '1rem' }}>
                Notifications
            </Typography>
            {unreadCount > 0 && (
                <Chip
                    label={unreadCount}
                    size="small"
                    sx={{ bgcolor: '#f44336', color: '#fff', fontWeight: 700, height: 20, fontSize: '0.7rem', ml: 0.5 }}
                />
            )}
        </Box>
        {unreadCount > 0 && (
            <Typography
                variant="caption"
                sx={{ color: 'rgba(255,255,255,0.85)', cursor: 'pointer', fontSize: '0.75rem',
                    '&:hover': { color: '#fff', textDecoration: 'underline' } }}
                onClick={markAllAsRead}
            >
                Mark all as read
            </Typography>
        )}
    </Box>

    {/* Notification list */}
  <Box
    ref={notifListRef}
    sx={{
        maxHeight: 390,
        overflowY: 'auto',
        '&::-webkit-scrollbar': { width: 5 },
        '&::-webkit-scrollbar-thumb': { background: '#c5cae9', borderRadius: 3 },
    }}
   onScroll={async (e) => {
    const el = e.currentTarget;
   if (el.scrollHeight - el.scrollTop - el.clientHeight < 60 && hasMoreRef.current && !loadingMoreNotifs) {
        setLoadingMoreNotifs(true);
        const next = notifPageNoRef.current + 1;
        notifPageNoRef.current = next;
        setNotifPageNo(next);
        await fetchNotifications(next, true);
        setLoadingMoreNotifs(false);
    }
}}
>
        {notifications.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 6, px: 3 }}>
                <NotificationsIcon sx={{ fontSize: 48, color: '#e0e0e0', mb: 1 }} />
                <Typography variant="body2" color="text.secondary" fontWeight={600}>
                    You're all caught up!
                </Typography>
                <Typography variant="caption" color="text.disabled">
                    No notifications yet.
                </Typography>
            </Box>
        ) : (
            notifications.map((notif, index) => {
                const typeColors = {
                    Reminder: '#ff9800', Success: '#4caf50',
                    Alert: '#f44336', Info: '#2196f3',
                };
                const dotColor = typeColors[notif.notificationType] || '#9c27b0';
                const initials = getDisplayName(notif.title || notif.name || '').charAt(0).toUpperCase() || '🔔';
                return (
                    <Box
                        key={notif.recipientId}
                        onClick={() => {
                            if (!notif.isRead) markAsRead(notif.recipientId);
                            
                        }}
                        sx={{
                            display: 'flex', gap: 1.5, px: 2, py: 1.5,
                            cursor: 'pointer',
                            bgcolor: !notif.isRead ? 'rgba(63,81,181,0.06)' : 'transparent',
                            borderBottom: index < notifications.length - 1 ? '1px solid #f0f0f0' : 'none',
                            transition: 'background 0.15s',
                            '&:hover': { bgcolor: !notif.isRead ? 'rgba(63,81,181,0.12)' : 'rgba(0,0,0,0.04)' },
                        }}
                    >
                        {/* Avatar with type dot */}
                        <Box sx={{ position: 'relative', flexShrink: 0 }}>
                            <Avatar sx={{
                                width: 42, height: 42, fontWeight: 700, fontSize: '1rem',
                                background: 'linear-gradient(135deg, #0B1F3D 0%, #1a3a6b 100%)',
                            }}>
                                {initials}
                            </Avatar>
                            <Box sx={{
                                position: 'absolute', bottom: 0, right: 0,
                                width: 12, height: 12, borderRadius: '50%',
                                bgcolor: dotColor, border: '2px solid #fff',
                            }} />
                        </Box>

                        {/* Content */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <Typography variant="subtitle2"
                                    fontWeight={notif.isRead ? 500 : 700}
                                    color={notif.isRead ? 'text.secondary' : 'text.primary'}
                                    sx={{ lineHeight: 1.3, flex: 1, pr: 1 }}
                                    noWrap
                                >
                                    {notif.title || getDisplayName(notif.name)}
                                </Typography>
                                <Typography variant="caption" color="text.disabled" sx={{ whiteSpace: 'nowrap', fontSize: '0.68rem', mt: 0.2 }}>
                                    {notif.createdOn
                                        ? new Date(notif.createdOn).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
                                        : 'Just now'}
                                </Typography>
                            </Box>
                           <Tooltip
    title={notif.message}
    placement="left"
    arrow
    componentsProps={{
        tooltip: {
            sx: {
                bgcolor: '#0B1F3D',
                color: '#fff',
                fontSize: '0.78rem',
                lineHeight: 1.6,
                maxWidth: 280,
                p: '10px 14px',
                borderRadius: 2,
                boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
            },
        },
        arrow: {
            sx: { color: '#0B1F3D' },
        },
    }}
>
    <Typography variant="body2" color="text.secondary"
        sx={{ fontSize: '0.8rem', lineHeight: 1.4, mt: 0.3,
            display: '-webkit-box', WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical', overflow: 'hidden',
            cursor: 'default' }}
    >
        {notif.message}
    </Typography>
</Tooltip>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
                                {notif.notificationType && (
                                    <Chip label={notif.notificationType} size="small"
                                        sx={{ height: 16, fontSize: '0.62rem', fontWeight: 600,
                                            bgcolor: `${dotColor}18`, color: dotColor, px: 0.5 }}
                                    />
                                )}
                                {!notif.isRead && (
                                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#3f51b5', ml: 'auto' }} />
                                )}
                            </Box>
                        </Box>
                    </Box>
                );
            })
        )}

        {/* Load more spinner */}
        {loadingMoreNotifs && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress size={20} sx={{ color: '#3f51b5' }} />
            </Box>
        )}
    </Box>

    {/* Footer */}
    {notifications.length > 0 && (
        <Box sx={{
            borderTop: '1px solid #f0f0f0', px: 2, py: 1,
            display: 'flex', justifyContent: 'center',
            bgcolor: 'grey.50',
        }}>
            <Typography
                variant="caption"
                sx={{ color: '#3f51b5', cursor: 'pointer', fontWeight: 600, fontSize: '0.78rem',
                    '&:hover': { textDecoration: 'underline' } }}
                onClick={() => { navigate('/notifications'); handleNotificationsClose(); }}
            >
                View all notifications →
            </Typography>
        </Box>
    )}
</Menu>

                        {/* Profile icon with user's name */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '8px' }}>
                           <IconButton color="inherit" onClick={handleMenuOpen} sx={{ p: 0.5 }}>
    <Avatar
        alt={OrgName}
        src={`https://wsmsv1.aidigitalsec.com${logo.replace('~', '')}`}
        variant="rounded"
        sx={{
            width: 40,
            height: 40,
            '& img': {
                objectFit: 'contain',
            },
        }}
    />
</IconButton>
                            <Typography className='enriqueta-medium' variant="subtitle1" color="inherit" onClick={handleMenuOpen} style={{ cursor: 'pointer' }}>
                                {clientName.replace(/['"]+/g, '')}
                            </Typography>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={handleAccountModalOpen}>Account</MenuItem>
                                <MenuItem onClick={handlePasswordChange}>Change Password</MenuItem>
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                <MenuItem style={{
                                    background: 'linear-gradient(90deg, #8491d9, #1e07cd)',
                                    color: 'white',
                                }}>Last Login: {lastlogin}</MenuItem> 

                            </Menu>
                        </div>

                    </Toolbar>
                </AppBar>


                {/* Account modal */}
              <Dialog
  open={accountModalOpen}
  onClose={handleAccountModalClose}
  PaperProps={{
    sx: {
      width: '420px',
      maxWidth: 'calc(100% - 40px)',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '0 32px 64px rgba(15,23,42,0.28)',
      maxHeight: '92vh',
    },
  }}
  BackdropProps={{
    sx: { backdropFilter: 'blur(6px)', backgroundColor: 'rgba(15,23,42,0.45)' },
  }}
>
  {/* ── Header ── */}
  <Box sx={{
    background: 'linear-gradient(135deg, #1a237e 0%, #3949ab 60%, #5c6bc0 100%)',
    px: 3, pt: 3, pb: 0,
    position: 'relative',
    zIndex: 10,
    overflow: 'visible',
    '&::before': {
      content: '""', position: 'absolute', top: -40, right: -40,
      width: 140, height: 140, borderRadius: '50%',
      background: 'rgba(255,255,255,0.06)',
      zIndex: 0,
    },
  }}>
   
    <Typography variant="h6" sx={{
      color: '#fff', fontWeight: 700,
      position: 'relative', zIndex: 1, mb: 2.5,
    }}>
      Account Overview
    </Typography>

    {/* Days strip — date only, no timing bar */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pb: 3, position: 'relative', zIndex: 1 }}>
      <Box sx={{
        width: 72, height: 72, borderRadius: '50%', flexShrink: 0,
        background: 'rgba(255,255,255,0.12)', border: '2.5px solid rgba(255,255,255,0.3)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}>
        <Typography sx={{ fontSize: 24, fontWeight: 700, color: '#fff', lineHeight: 1 }}>{day}</Typography>
        <Typography sx={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', mt: '2px' }}>Days</Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.9)', mb: 0.5 }}>
          Days Remaining
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.55)' }}>
          Renews on {expirydate}
        </Typography>
      </Box>
      <Chip label="● Active" size="small" sx={{
        background: 'rgba(52,211,153,0.18)', border: '1px solid rgba(52,211,153,0.4)',
        color: '#6ee7b7', fontWeight: 600, fontSize: 11, alignSelf: 'flex-start', mt: 0.5,
      }} />
    </Box>
  </Box>

  {/* ── Body ── */}
  <DialogContent sx={{ p: '20px 24px', background: '#f8f9fc', overflowY: 'auto', position: 'relative', zIndex: 1 }}>

    {/* Plan details */}
    <Typography variant="overline" sx={{ color: '#9ca3af', letterSpacing: 1.1, fontWeight: 700, display: 'block', mb: 1.5 }}>
      Plan Details
    </Typography>
    <Paper elevation={0} sx={{ border: '1px solid #e5e9f0', borderRadius: '14px', mb: 2, overflow: 'hidden' }}>
      {[
        { icon: '📋', bg: '#eff3ff', label: 'Subscription', value: 'Active', valueColor: '#059669' },
        { icon: '📅', bg: '#fff0f3', label: 'Expires On',   value: expirydate },
        { icon: '✉️', bg: '#f0fdf9', label: 'Support',      value: 'info@warals.com' },
      ].map(({ icon, bg, label, value, valueColor }, i, arr) => (
        <Box key={label} sx={{
          display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5,
          borderBottom: i < arr.length - 1 ? '1px solid #f1f3f8' : 'none',
        }}>
          <Box sx={{ width: 32, height: 32, borderRadius: '9px', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}>
            {icon}
          </Box>
          <Typography variant="body2" sx={{ flex: 1, color: '#6b7280', fontWeight: 500 }}>{label}</Typography>
          <Typography variant="body2" sx={{ fontWeight: 600, color: valueColor || '#111827' }}>{value}</Typography>
        </Box>
      ))}
    </Paper>

    {/* Storage */}
    <Typography variant="overline" sx={{ color: '#9ca3af', letterSpacing: 1.1, fontWeight: 700, display: 'block', mb: 1.5, mt: 0.5 }}>
      Storage Usage
    </Typography>
    <Paper elevation={0} sx={{ border: '1px solid #e5e9f0', borderRadius: '14px', p: 2 }}>
      {loadingStorage ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>
      ) : storageData ? (
        <>
          {(() => {
            const LIMIT_MB = 300;
            const totalUsedMB = storageData.summary.totalUsedMB;           // adjust key if different
            const usedPct = Math.min((totalUsedMB / LIMIT_MB) * 100, 100);
            const isCritical = usedPct >= 90;
            const isWarning  = usedPct >= 70 && usedPct < 90;

           const bars = [
  {
    name: 'Database', dotColor: '#3949ab',
    value: `${storageData.summary.databaseUsedMB.toFixed(2)} MB`,
    pct: Math.min((storageData.summary.databaseUsedMB / LIMIT_MB) * 100, 100),
    barSx: { background: 'linear-gradient(90deg,#3949ab,#5c6bc0)' },
  },
  {
    name: 'Files', dotColor: '#f59e0b',
    value: `${storageData.summary.fileStorageMB.toFixed(2)} MB`,
    pct: Math.min((storageData.summary.fileStorageMB / LIMIT_MB) * 100, 100),
    barSx: { background: 'linear-gradient(90deg,#f59e0b,#fbbf24)' },
  },
];

            return (
              <>
                {bars.map(({ name, dotColor, value, pct, barSx }) => (
                  <Box key={name} sx={{ mb: 1.75 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: dotColor }} />
                        <Typography variant="caption" sx={{ color: '#6b7280', fontWeight: 500 }}>{name}</Typography>
                      </Box>
                      <Typography variant="caption" sx={{ fontWeight: 700, color: '#111827' }}>{value}</Typography>
                    </Box>
                    <LinearProgress variant="determinate" value={pct} sx={{
                      height: 7, borderRadius: 99, backgroundColor: '#f1f3f8',
                      '& .MuiLinearProgress-bar': { ...barSx, borderRadius: 99 },
                    }} />
                  </Box>
                ))}

                {/* Soft warning banner */}
                {(isCritical || isWarning) && (
                  <Box sx={{
                    mt: 0.5, mb: 1.5,
                    borderRadius: '10px',
                    background: isCritical ? 'rgba(239,68,68,0.08)'  : 'rgba(245,158,11,0.08)',
                    border: `1px solid ${isCritical ? 'rgba(239,68,68,0.25)' : 'rgba(245,158,11,0.25)'}`,
                    px: 1.5, py: 1,
                    display: 'flex', alignItems: 'center', gap: 1,
                  }}>
                    <Typography sx={{ fontSize: 15 }}>{isCritical ? '🔴' : '🟡'}</Typography>
                    <Box>
                      <Typography variant="caption" sx={{
                        fontWeight: 700,
                        color: isCritical ? '#dc2626' : '#b45309',
                        display: 'block',
                      }}>
                        {isCritical ? 'Storage almost full' : 'Storage running low'}
                      </Typography>
                      <Typography variant="caption" sx={{ color: isCritical ? '#ef4444' : '#d97706', fontSize: 10.5 }}>
                        {isCritical
                          ? 'You have used over 90% of your 300 MB limit. Please free up space.'
                          : 'You have used over 70% of your 300 MB limit. Consider cleaning up files.'}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Total */}
                <Box sx={{
                  mt: 0.25, borderRadius: '12px',
                  background: 'linear-gradient(135deg,#0f172a,#1e3a5f)',
                  p: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}>
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>Total Used</Typography>
                 <Typography variant="body2" sx={{ color: '#fff', fontWeight: 800, fontSize: 15 }}>
  {storageData.summary.totalUsedMB.toFixed(2)} MB <Typography component="span" sx={{ fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.45)' }}>/ 300 MB</Typography>
</Typography>
                </Box>
              </>
            );
          })()}
        </>
      ) : (
        <Typography variant="caption" color="text.secondary">Storage info unavailable.</Typography>
      )}
    </Paper>
  </DialogContent>

  {/* ── Footer ── */}
  <DialogActions sx={{ px: 3, py: 1.75, borderTop: '1px solid #e5e9f0', background: '#fff' }}>
    <Button onClick={handleAccountModalClose} variant="contained" sx={{
      background: 'linear-gradient(135deg,#1a237e,#3949ab)',
      borderRadius: '10px', px: 3, py: 1.2, fontWeight: 600, fontSize: 13,
      boxShadow: '0 2px 8px rgba(57,73,171,0.35)',
      '&:hover': { opacity: 0.88, boxShadow: '0 4px 14px rgba(57,73,171,0.45)' },
    }}>
      Close
    </Button>
  </DialogActions>
</Dialog>

                <Drawer
                    variant="persistent"
                    anchor="left"
                    open={open}
                    sx={{
                        width: drawerWidth, // Use the dynamically set drawer width
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: 250,
                            zIndex: (theme) => theme.zIndex.drawer,
                            backgroundColor: '#0B1F3D', // Add your background color here
                            color: 'white', // Add your text color here
                        },
                    }}
                    // Add transition component
                    transitionDuration={{ enter: 500, exit: 500 }} // Adjust duration as needed
                    TransitionComponent={Slide}
                    // Set direction to 'right' for the drawer to slide from the right
                    direction="right"
                >
                    <Toolbar />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', paddingLeft: '10px', paddingBottom: '15px' }}>
                       <Avatar
    alt={OrgName}
    src={`https://wsmsv1.aidigitalsec.com${logo.replace('~', '')}`}
    sx={{
        width: 40,
        height: 40,
        bgcolor: 'white',        // white background fills empty space
        '& img': {
            objectFit: 'contain',  // shows full logo without cropping
            padding: '4px',        // small padding so logo doesn't touch the circle edge
        },
    }}
/>
                        <div>
                            <Typography variant="h6" component="div" color="white" >
                                {OrgName}
                            </Typography>
                            {/* <Typography variant="body2" color="white">
                                {OrgName}
                            </Typography> */}
                        </div>
                    </div>


                    <List>
                        <ListItemButton component={Link} to="/dashboard">
                            <ListItemIcon className="white-icon-color" style={{ color: 'white' }}>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" />
                        </ListItemButton>

                        {data.map((module) => (
                            <div key={module.moduleId}>
                                <ListItemButton onClick={() => handleModuleItemClick(module.moduleId)}>
                                    <ListItemIcon style={{ color: 'white' }}>
                                        {moduleIcons[module.moduleName] || moduleIcons.default}
                                    </ListItemIcon>
                                    <ListItemText primary={module.moduleName} />
                                    {moduleOpenState[module.moduleId] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </ListItemButton>

                                <DropdownMenu moduleId={module.moduleId} items={formData} />
                            </div>
                        ))}
                    </List>
                </Drawer>

                <div
                    onClick={handleCloseDrawer}
                    style={{
                        flexGrow: 1,
                        padding: '20px',
                    }}
                >
                    <Toolbar />
                    <main>
                        {content}
                    </main>
                </div>
                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={4000}
                    onClose={() => setOpenSnackbar(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        </>
    );
};

export default Sidebar;